module.exports = __webpack_public_path__ + "img/help_kids_learn.97cc5b42.jpg";